// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37B4a","largestCol":"styles_largestCol__1CzUE","smallestCol":"styles_smallestCol__2Bssb"};